import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PopMenu from './popMenu';
import styles from './index.module.scss';

function Nav() {

  const {
    navData: {
      category = {},
      mainCategory = [],
      navigationBar = []
    }
  } = useSelector(state => state.commonReducer);

  const [subContent, setSubContent] = useState({});
  const [hoverIndex, setHoverIndex] = useState(-1);
  const [showMenu, setShowMenu] = useState(false);


  const showPopMenu = (hoverIndex, mainCategoryItem) => {
    const subMenu = mainCategoryItem?.popTwoCategory || [];
    const subBrands = mainCategoryItem?.categoryRecommendBrand || [];
    const subAd = mainCategoryItem?.categoryChannelLink || [];
    setHoverIndex(hoverIndex)
    setSubContent({
      subMenu,
      subBrands,
      subAd
    })
  }

  const mouseEnterCategory = () => {
    setShowMenu(true)
  }

  const mouseLeaveCategory = () => {
    setShowMenu(false);
    setHoverIndex(-1);
    setSubContent({});
  }

  const handleEnterMenu = () => {
    setShowMenu(true);
  }


  return (
    <div className={styles["nav-2014"]}>
      <div className={`${styles.w} w`}>
        <div className={`${styles["categorys-2014"]}`} onMouseLeave={mouseLeaveCategory}>
          <div className={styles.dt} onMouseEnter={mouseEnterCategory} >
            <a target="_blank" href={category.linkText} rel="noopener noreferrer">
              {
                category.icon && <i style={{ backgroundImage: `url(${category.icon})` }}></i>
              }
              {category.text}
            </a>
          </div>
          {
            showMenu && (
              <div className={styles.dd} onMouseEnter={handleEnterMenu}>
                <div className={styles["dd-inner"]}>
                  {
                    mainCategory.map((mainCategoryItem, mainCategoryItemIdx) => {
                      const title = mainCategoryItem?.text;
                      const mainTextLink = mainCategoryItem?.mainTextLink || [];
                      const icon = mainCategoryItem?.icon || '';
                      const hoverIcon = mainCategoryItem?.selectIcon || '';
                      return (
                        <div className={`${styles.item} ${mainCategoryItemIdx === hoverIndex ? styles.hover : null}`} key={title} onMouseEnter={() => showPopMenu(mainCategoryItemIdx, mainCategoryItem)}>
                          <h3>
                            <i style={{ backgroundImage: `url(${mainCategoryItemIdx === hoverIndex ? hoverIcon : icon})` }}></i>
                            <a target="_blank" href={mainCategoryItem?.linkText} rel="noopener noreferrer">
                              {title}
                            </a>
                            <b className={styles["arrow-right"]}>
                            </b>
                          </h3>
                          {
                            mainTextLink.map(sub => (
                              <h4 key={sub?.text}>
                                <a target="_blank" href={sub?.linkText} rel="noopener noreferrer">
                                  {sub?.text}
                                </a>
                              </h4>
                            ))
                          }
                        </div>
                      )
                    })
                  }
                </div>
                {
                  hoverIndex > -1 && <PopMenu content={subContent} hoverIndex={0}/>
                }
              </div>
            )
          }
        </div>
        <div className={styles["navitems-2014"]}>
          <ul>
            {
              navigationBar.map((navBarItem, navBarItemIdx) => {
                const text = navBarItem?.text || ''
                const actImg = navBarItem?.actImg || ''
                const imgLogo = navBarItem?.imgLogo || ''
                const linkText = navBarItem?.linkText || 'https://www.jd.hk/'
                return (
                  <li key={navBarItemIdx} clstag={`firsttype|keycount|jdworldwide|nav${navBarItemIdx + 1}`}>
                    <a target="_blank" href={linkText} rel="noopener noreferrer">
                      {
                        !text ? (!actImg ? null : <img src={actImg} className={styles["nav-logo"]} alt="" />) : text
                      }
                      {
                        !imgLogo ? null : <img src={imgLogo} className={styles["nav-icon"]} alt="" />
                      }
                    </a>
                  </li>
                )
              })
            }
          </ul>
        </div>


        <span className="clr"></span>
        <div className={styles["nav-ad"]}></div>
      </div>
    </div>
  )
}

export default Nav;